export function getInitials(name) {
  if (name === void 0) {
    name = '';
  }

  if (typeof name !== 'string') return '';
  var names = name.split(' ').map(function (name) {
    return name.charAt(0);
  }).filter(function (name, index) {
    return index < 2;
  }).join('');
  return names;
}